import type { FC, ReactNode } from 'react';
import { useMemo } from 'react';

import { Tooltip } from '@base-ui/react/tooltip';

import { useLocalStorageState } from '@tripleten/state-hooks/use-local-storage-state';

import { Slot } from '../../slot/slot.tsx';
import type { Appearance } from '../theme.context.ts';
import { ThemeContext } from '../theme.context.ts';

export type ThemeProviderRootProps = {
    appearance?: Appearance;
    children?: ReactNode;
};

export const ThemeProviderRoot: FC<ThemeProviderRootProps> = ({ appearance: appearanceProp, children }) => {
    const [storedAppearance, setStoredAppearance] = useLocalStorageState<Appearance>(
        'design-system.appearance-preference',
    );
    const appearance = appearanceProp ?? storedAppearance ?? 'inherit';
    const setAppearance = appearanceProp ? undefined : setStoredAppearance;

    const contextValue = useMemo(() => ({ appearance, isRoot: false, setAppearance }), [appearance, setAppearance]);

    return (
        <ThemeContext.Provider value={contextValue}>
            <Tooltip.Provider delay={200}>
                <Slot data-appearance={appearance}>{children}</Slot>
            </Tooltip.Provider>
        </ThemeContext.Provider>
    );
};
